import { HttpClient } from '@angular/common/http';
import { inject, Injectable, isDevMode } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { catchError, of } from 'rxjs';
import { availableLocales, defaultLocale } from './i18n-locales';

@Injectable({ providedIn: 'root' })
class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`).pipe(
      catchError(error => {
        // Surface the failure for ops debugging but DO NOT propagate the
        // HttpErrorResponse as the "translation" — Transloco would then
        // hand it to the lookup pipeline as if it were a Translation map,
        // every lookup would miss, and every component would render raw
        // keys. Returning an empty translation lets Transloco's
        // missing-key fallback take over instead.
        console.error('Error fetching i18n data:', error);
        return of({} as Translation);
      })
    );
  }
}

export const configTransloco = {
  config: {
    availableLangs: availableLocales,
    defaultLang: defaultLocale,
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
    failedRetries: 1,
    fallbackLang: defaultLocale,
    missingHandler: {
      useFallbackTranslation: true,
    },
    // flatten.aot=true tells Transloco the loaded JSON is ALREADY FLAT.
    // Our dictionaries are nested, so aot in prod broke every lookup and
    // surfaced raw keys. Force false so Transloco walks the nested
    // structure at runtime.
    flatten: {
      aot: false,
    },
  },
  loader: TranslocoHttpLoader,
};
